import store from "@/store/store";
import router from "@/router";

let redirecting = false;

/**
 * session หมดอายุ (backend 401 / Facebook token ใช้ไม่ได้) → ล้างการ login แล้วพาไปหน้า /login ปกติ
 * (แทน LoginModal เดิม) — ต้องล้าง token ก่อน ไม่งั้น router guard จะเด้งจาก /login กลับ "/"
 * กันเรียกซ้ำเมื่อหลาย request ได้ 401 พร้อมกัน
 */
export async function redirectToLogin() {
    if (redirecting) return;
    const name = router.currentRoute.value.name;
    if (["login", "register", "logout"].includes(name)) return;

    redirecting = true;
    try {
        await store.dispatch("logout");
    } catch (err) {
        console.warn("logout ระหว่าง session หมดอายุไม่สำเร็จ", err);
    }
    try {
        await router.replace("/login");
    } catch (err) {
        console.warn("Router error:", err);
    } finally {
        redirecting = false;
    }
}
